import usePrivateAxios from '@/common/api/usePrivateAxios';
import { useMutation } from '@tanstack/react-query';

interface UseBillingBillSendBillToIntegrationProcessProps {
  id?: string;
  onSuccess?: (response: any) => void;
  onError?: (response: any) => void;
}

export const useBillingBillSendBillToIntegrationProcess = ({ id, onSuccess, onError }: UseBillingBillSendBillToIntegrationProcessProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['billingBillSendBillToIntegrationProcess', id],
    mutationFn: ({ bypass_bill_status }: { bypass_bill_status?: boolean }) => {
      return privateAxios.put(`/billing/bills/${id}/send_bill_to_integration_process`, { bypass_bill_status });
    },
    onSuccess,
    onError,
  });
};
